/**
 * Get localized title based on current language
 * Falls back to English if translation is not available
 */
export function getLocalizedTitle(
  entity: {
    title: string;
    title_de?: string | null;
    title_fa?: string | null;
  },
  language: string
): string {
  switch (language) {
    case 'de':
      return entity.title_de || entity.title;
    case 'fa':
      return entity.title_fa || entity.title;
    default:
      return entity.title;
  }
}

/**
 * Get localized description based on current language
 * Falls back to English if translation is not available
 */
export function getLocalizedDescription(
  entity: {
    description: string;
    description_de?: string | null;
    description_fa?: string | null;
  },
  language: string
): string {
  switch (language) {
    case 'de':
      return entity.description_de || entity.description;
    case 'fa':
      return entity.description_fa || entity.description;
    default:
      return entity.description;
  }
}

/**
 * Get both localized title and description
 */
export function getLocalizedContent<
  T extends {
    title: string;
    description: string;
    title_de?: string | null;
    description_de?: string | null;
    title_fa?: string | null;
    description_fa?: string | null;
  }
>(entity: T, language: string): { title: string; description: string } {
  return {
    title: getLocalizedTitle(entity, language),
    description: getLocalizedDescription(entity, language),
  };
}
